import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { transactionsUtils } from 'app-components/flux/transactions';

import Box from '@mui/material/Box';
import { List } from 'immutable';

import MuiTagsField from 'components/QuickenControls/TagsField/TagsField';
import SymbolLookupField from 'components/SymbolLookupField';

const InvestmentTransactionBaseForm = (props) => {
  const { formik } = props;

  useEffect(() => {
    formik.registerField('securityName', {
      validate: (value) => (value || formik.values.symbol || formik.values.localSecurityId ? undefined : 'required'),
    });
    return () => {
      formik.unregisterField('securityName');
    };
  }, [formik]);

  const securitiesEnabled = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'securities'));

  return (
    <Box display='flex' gap={2}>
      <SymbolLookupField
        id='symbol-lookup'
        label='Security'
        sx={{ width: 400 }}
        hideCreateOption={!securitiesEnabled}
        value={transactionsUtils.security(formik.values)}
        onSelected={(item) => {
          formik.setFieldValue('fullSecurity', item); // For security creation
          formik.setFieldValue('symbol', item.symbol || '');
          formik.setFieldValue('securityName', item.name || '');
          formik.setFieldValue('localSecurityId', item.security?.id || '');
          formik.setFieldValue('securityIdType', item.security?.securityIdType || '');
          formik.setFieldValue('securityId', item.security?.securityId || '');
          formik.setFieldValue('sharesPerContract', item.security?.sharesPerContract);
        }}
        error={Boolean(formik.submitCount > 0 && formik.errors.securityName)}
        helperText={(formik.submitCount > 0 && formik.errors.securityName) || ''}
        onFocus={(event) => event.target.select()}
        autoFocus
      />
      <MuiTagsField
        id='tags'
        value={Array.isArray(formik.values.tags) ? formik.values.tags : formik.values.tags?.toArray()}
        onChange={(_e, tagArray, _reason, _details) => formik.setFieldValue('tags', List(tagArray))}
      />
    </Box>
  );
};

InvestmentTransactionBaseForm.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default InvestmentTransactionBaseForm;
